import { CSTDateFormatterWithTime_12_hr, DateFormatTo_MM_DD_YYYY } from "../utils/DateFormatter"
import { DUAL_ACCOUNT_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, PART_D_PREDETERMINATION_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT } from "./reportNames"

// Constants for button labels
export const OK='OK'
export const CANCEL='CANCEL'
export const ACTIVE='Acitve'
export const INACTIVE='Inactive'

// Array of team names
export const TEAMS=['OFFSHORE','ONSHORE','OFFSHORE LOAN AGENTS','ONSHORE LOAN AGENTS']

// Array of reviewer statuses
export const REVIEWERSTATUS=[ACTIVE, INACTIVE]

// Constants for save actions
export const SAVEDRAFT=0;
export const SAVE=1;

// Constants for task statuses
export const COMPLETED='Completed'
export const INPROGRESS='In-Progress'
export const UNASSIGNED='Unassigned'
export const ASSIGNED='Assigned'

// Object mapping columns with date fields to a flag (1 indicates a date field)
export const Columns_With_Date = {
    'DATE_TIME_FAX_RECEIVED' : CSTDateFormatterWithTime_12_hr,
    'MEMBER_DOB': DateFormatTo_MM_DD_YYYY,
    'SLA_COMPLIANCE_R2':CSTDateFormatterWithTime_12_hr,
    'CREATE_DATE_R2':CSTDateFormatterWithTime_12_hr,
    'RESOLVED_DATE_R2':CSTDateFormatterWithTime_12_hr,
    'SLACOMPLIANCE':CSTDateFormatterWithTime_12_hr,
    'REQUESTRECIEVEDDATE':CSTDateFormatterWithTime_12_hr,
    'DISPOSITIONDATE':CSTDateFormatterWithTime_12_hr,
}


// Object mapping each report to completed question
export const COMPLETE_Question_Of_Report = {
    [DUAL_ACCOUNT_REPORT]: {
        question_id: 17, 
        value_id: 41 // Assuming you want to set it to null or some default value
    },
    [INBOUND_CORR_WB_REPORT]: {
        question_id: 30,
        value_id: 22 // Add value_id if needed
    },
    [PART_D_DUPLICATE_REPORT]: {
        question_id: 42,
        value_id: 76 // Add value_id if needed
    },
    [PART_D_IE_REPORT]: {
        question_id: 66,
        value_id: 80 // Add value_id if needed
    },
    [PART_D_MULTIPLE_REPORT]: {
        question_id: undefined,
        value_id: null // Add value_id if needed
    },
    [RESOLVED_COMPLETED_REPORT]: {
        question_id: 83,
        value_id: 48 // Add value_id if needed
    },
    [TRANSITIONAL_OVERRIDE_REPORT]: {
        question_id: undefined,
        value_id: null // Add value_id if needed
    },
    [UHCEI_DUPLICATE_DENIAL_REPORT]: {
        question_id: 106,
        value_id: 36 // Add value_id if needed
    },
    [XCPINDEXING_REPORT]: {
        question_id: 117,
        value_id: 23 // Add value_id if needed
    },
    [PART_D_PREDETERMINATION_REPORT]: {
        question_id: undefined,
        value_id: null // Add value_id if needed
    },
};

